import { createIcon } from '@chakra-ui/react';

export const AddIcon = createIcon({
  displayName: 'AddIcon',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <g clipPath="url(#clip0_2739_35061)">
          <path
            d="M13.0871 8.22658L13.0871 7.08713L8.56973 7.08713L8.56973 2.56973H7.43027L7.43027 7.08713L2.91287 7.08713L2.91287 8.22658L7.43027 8.22658L7.43027 12.744H8.56973L8.56973 8.22658L13.0871 8.22658Z"
            fill="#6E6789"
          />
        </g>
        <defs>
          <clipPath id="clip0_2739_35061">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  ),
});
